import OrderSimpleView from './OrderSimpleView'

export default OrderSimpleView
